<mat-form-field>
    <mat-label>{{ custControl.label}}</mat-label>
    <input matInput [formControl]="inputControl" [readonly]="isReadonly" (input)="onInputChange($event)"/>
</mat-form-field>
